import React, { FC, useState, useEffect, useCallback, useMemo } from 'react'

import { Grid, Button, Container, Icon, Menu, Segment, Card, Image } from 'semantic-ui-react'

import { themes } from '@/theme/context'
import { CustomCardGroup, FlexBlock, TabletOnlyGrid, MobileOnlyGrid, Link } from '@/components/OtherCustomComponents/style'
import { FullWidthBackgroundContainer, ThemedText, BodySegment, ThemedSegment, BodyContainer, CustomImage } from './style'

export const BodyComponent = ({drupalHost, currentAct}) => {
    return (<BodyContainer>
        <FullWidthBackgroundContainer>
            <Container>
                <CustomCardGroup itemsPerRow={2} stackable>
                    <Card>
                        <Card.Content>
                            <FlexBlock>
                                <Image spaced="right" src="/themes/training/images/training7.svg" />
                                <b>Студенческие режимы<br/> «Обучение» и «Самоконтроль»</b>
                            </FlexBlock>
                            <p>Помогают студенту закрепить пройденный материал и самостоятельно оценить уровень освоения дисциплины в&nbsp;процессе подготовки к&nbsp;контрольному тестированию</p>
                        </Card.Content>
                    </Card>
                    <Card>
                        <Card.Content>
                            <FlexBlock>
                                <Image spaced="right" src="/themes/training/images/training4.svg" />
                                <b>Преподавательский режим<br/> «Текущий контроль»</b>
                            </FlexBlock>
                            <p>Позволяет преподавателю оценить целостность и прочность усвоения материала, провести промежуточный контроль знаний, в&nbsp;том числе по&nbsp;самостоятельно разработанным тестовым заданиям</p>
                        </Card.Content>
                    </Card>
                </CustomCardGroup>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <p>Оценка качества подготовки обучающихся, проведенная с&nbsp;помощью сервиса «{themes[currentAct].title}», может быть определена как вид внутренней системы оценки качества образования (<Link href="/node/1668">ВСОКО</Link>) и зачтена при&nbsp;прохождении государственных аккредитационных процедур контроля.</p>
            <BodySegment>
                <p>Интернет-тренажеры предусматривают проведение тестирования студентов <ThemedText><Link href="/fgos_pim_struct">по&nbsp;дисциплинам</Link></ThemedText> высшего и среднего профессионального образования, а также по&nbsp;дисциплинам <ThemedText><Link href="/node/861">общеобразовательного цикла</Link></ThemedText>  (для&nbsp;обучающихся по&nbsp;профессиям и/или специальностям СПО на&nbsp;базе 9 классов).</p>
                    <p>Система тестирования отличается широким разнообразием представленных в&nbsp;сервисах портала <ThemedText><Link href={`//test.${drupalHost}/demo/training/student/index.html?alltypes`}>типов заданий</Link></ThemedText>, позволяющих эффективно оценивать образовательные достижения студентов.</p>
            </BodySegment>
        </Container>
        <Container>
            <TabletOnlyGrid>
                <Grid.Row>
                    <Grid.Column tablet={7} computer={8}>
                        <b>Особенности режима</b>
                    </Grid.Column>
                    <Grid.Column width={4} textAlign='center'>
                        <ThemedSegment inverted>«Обучение»</ThemedSegment>
                    </Grid.Column>
                    <Grid.Column tablet={5} computer={4} textAlign='center'>
                        <ThemedSegment inverted>«Самоконтроль»</ThemedSegment>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column tablet={7} computer={8}>
                        получение подсказок в&nbsp;случае выбора неправильного ответа
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px"/>
                    </Grid.Column>
                    <Grid.Column tablet={5} computer={4}>
                        <CustomImage centered src="/themes/training/images/training2.svg" $height="30px"/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column tablet={7} computer={8}>
                        возможность ознакомиться с&nbsp;текстом правильного решения
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px"/>
                    </Grid.Column>
                    <Grid.Column tablet={5} computer={4}>
                        <CustomImage centered src="/themes/training/images/training2.svg" $height="30px"/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column tablet={7} computer={8}>
                        наличие справочных материалов
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px"/>
                    </Grid.Column>
                    <Grid.Column tablet={5} computer={4}>
                        <CustomImage centered src="/themes/training/images/training2.svg" $height="30px"/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column tablet={7} computer={8}>
                        предоставление протоколов с&nbsp;указанием правильных/неправильных ответов
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px"/>
                    </Grid.Column>
                    <Grid.Column tablet={5} computer={4}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px"/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column tablet={7} computer={8}>
                        ограничение по&nbsp;времени
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <CustomImage centered src="/themes/training/images/training2.svg" $height="30px"/>
                    </Grid.Column>
                    <Grid.Column tablet={5} computer={4}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px"/>
                    </Grid.Column>
                </Grid.Row>
            </TabletOnlyGrid>
            <MobileOnlyGrid>
                <Grid.Row>
                    <Grid.Column textAlign="center">
                        <b>Особенности режима <ThemedSegment inverted>«Обучение»</ThemedSegment></b>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        получение подсказок в&nbsp;случае выбора неправильного ответа
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        возможность ознакомиться с&nbsp;текстом правильного решения
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        наличие справочных материалов
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        предоставление протоколов с&nbsp;указанием правильных/неправильных ответов
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        ограничение по&nbsp;времени
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training2.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column textAlign="center">
                        <b>Особенности режима <ThemedSegment inverted>«Самоконтроль»</ThemedSegment></b>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        получение подсказок в&nbsp;случае выбора неправильного ответа
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training2.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        возможность ознакомиться с&nbsp;текстом правильного решения
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training2.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        наличие справочных материалов
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training2.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        предоставление протоколов с&nbsp;указанием правильных/неправильных ответов
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={13}>
                        ограничение по&nbsp;времени
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <CustomImage centered src="/themes/training/images/training1.svg" $height="30px" />
                    </Grid.Column>
                </Grid.Row>
            </MobileOnlyGrid>
        </Container>
        <FullWidthBackgroundContainer>
            <Container>
                <p>При&nbsp;формировании плана тестирования в&nbsp;режиме «Текущий контроль» преподаватель имеет возможность самостоятельно настраивать <b>дополнительные опции:</b></p>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <FlexBlock className='streamlined'>
                                <CustomImage $margin="5px .8em auto 0" src="/themes/training/images/training6.svg" />
                                <div><Link target="_blank" href="/sites/default/files/training/user_guide_teach_tren.pdf#page=8">Сессия</Link> — невозможность возврата к&nbsp;ранее выполненным (просмотренным) заданиям</div>
                            </FlexBlock>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <FlexBlock className='streamlined'>
                                <CustomImage $margin="5px .8em auto 0" src="/themes/training/images/training5.svg" />
                                <div><Link target="_blank" href="/sites/default/files/training/user_guide_teach_tren.pdf#page=9">Прокторинг</Link> — организация видеонаблюдения за&nbsp;сеансом тестирования</div>
                            </FlexBlock>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <FlexBlock className='streamlined'>
                                <CustomImage $margin="5px .8em auto 0" src="/themes/training/images/training9.svg" />
                                <div>«Диагностическая работа» — формат тестирования с&nbsp;включением «комбинированного типа» заданий, предполагающего выбор правильного варианта(-ов) ответа и обоснование выбора (в&nbsp;соответствии с&nbsp;методическими рекомендациями для&nbsp;экспертов при&nbsp;проведении диагностической работы в&nbsp;организациях <Link target="_blank" href="/sites/default/files/sites/diagnosticheskaya-rabota-v-gosudarstvennoj-reglamentacii-obrazovatelnoj-deyatelnosti-vysshee-obrazovanie-metodicheskie-rekomendacii-dlya-ehkspertov.pdf#page=29">высшего</Link> и <Link target="_blank" href="/sites/default/files/sites/diagnosticheskaya-rabota-v-gosudarstvennoj-reglamentacii-obrazovatelnoj-deyatelnosti-srednee-professionalnoe-obrazovanie-metodicheskie-rekomendacii-dlya-ehkspertov.pdf#page=29">среднего профессионального</Link> образования)</div>
                            </FlexBlock>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <br/>
                <p>Реализована <Link target="_blank" href="/sites/default/files/instruktsya.pdf">интеграция</Link> Интернет-тренажеров как&nbsp;внешнего приложения в&nbsp;систему <ThemedText><b>Moodle</b></ThemedText></p>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <BodySegment>
                Результаты тестирования студентов будут отражены в&nbsp;рейтинг-листах.<br/>
                Интернет-тренажеры могут быть использованы как&nbsp;инструмент <b>создания внутренней системы оценки качества образования</b> и уникального фонда оценочных средств для&nbsp;проведения <b>диагностической работы,</b> а также в&nbsp;качестве тренировочного сервиса для&nbsp;подготовки к&nbsp;процедурам <b>внешней независимой оценки.</b>
            </BodySegment>
        </Container>
        <Container>
            <Grid stackable>
                <Grid.Row>
                    <Grid.Column width={3}>
                        <Image centered size="small" src="/themes/defaultNiimko/images/test_constructor/logo.svg?ai"/>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <p><ThemedText><Link href={'/test_constructor'}><b>«Тест-Конструктор с нейросетями»</b></Link></ThemedText></p>
                        <p>Программный модуль для&nbsp;самостоятельной разработки преподавателями тестовых заданий по&nbsp;уникальным, узкоспециальным дисциплинам и создания измерительных материалов на&nbsp;основе федерального банка портала i-exam.ru.</p>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    </BodyContainer>)
}